import { HTMLProps } from 'react'

export type MdListItemProps = HTMLProps<HTMLLIElement>

export const MdListItem = ({ children, ...rest }: MdListItemProps) => {
  return <li {...rest}>{children}</li>
}
